import { createContext, useContext } from 'react';
import { Connector } from 'wagmi';

import { DepositAction } from './types';

export interface AccountData {
  ethAccount?: string;
  ethBalance?: bigint;
}

export interface CreateOfferArgs {
  receiver?: string;
  sendAmountInEth?: string;
  receiveAmountInEth?: string;
  sendCardIds?: string[];
  receiveCardIds?: string[];
  endingAt?: string;
}

export interface EthereumAccountHandler {
  resolve: (v: AccountData) => void;
  reject: (reason: any) => void;
}

export type InitEthereumSource = 'InBackground' | 'OnUserRequest';

export interface BlockchainContext {
  loading: boolean;
  activeConnector: Connector | undefined;
  isConnected: boolean;
  wrongChain: boolean;
  ethAddress: EthereumAddress | undefined;
  ethBalance: bigint | undefined;
  depositEth: (amountInWei: bigint) => Promise<null | {
    result?: EthereumAddress | null;
    err?: Error;
  }>;
  depositNft: (
    contractAddress: EthereumAddress,
    assetId: string
  ) => Promise<null | {
    err?: Error;
    txHash?: string;
    type?: DepositAction;
  }>;
  connectToEthereum: (connector: Connector) => void;
  disconnect: () => void;
  setupWalletConnect: () => Promise<void>;
  setupCoinbaseWallet: () => Promise<void>;
  setupLedger: () => Promise<void>;
  connectors: Connector[];
  ethereumNetworkId?: string;
  expectedEthereumNetwork?: string;
  reset: () => void;
}

export const blockchainContext = createContext<BlockchainContext | null>(null);

export const useBlockchainContext = () => useContext(blockchainContext)!;

export default blockchainContext.Provider;
